import './ProductBlock.scss'

import {ImageType, WysiwygType} from '../../types'

import {Block} from './Blocks'
import {Link} from '../../util/link'
import {ProductImage} from '../../views/webshop/layout/product/ProductImage'
import React from 'react'
import {Theme} from '../../views/Theme'
import {style} from '../../util/style'

const styles = style('productblock')

export type ProductBlockType = {
	url: string
	title: string
	preview_blur?: boolean
	preview_image: ImageType
	preview_title: string
	preview_text: WysiwygType
	hero_title: string
	hero_text: WysiwygType
	btnlabel: string
}

export const ProductBlock: React.FC<
	ProductBlockType & {container?: boolean}
> = ({
	container,
	url,
	title: pageTitle,
	preview_blur,
	preview_image,
	preview_title,
	preview_text,
	hero_title,
	hero_text,
	btnlabel
}) => {
	const title = preview_title || hero_title || pageTitle
	const text = preview_text || hero_text
	if (!preview_image?.src && !title && !text) return null

	return (
		<Block className={styles()} container={container}>
			<div className={styles('row')}>
				{preview_image && (
					<Link to={url} className={styles('image')}>
						<ProductImage
							image={preview_image}
							blur={preview_blur}
							title={title}
						/>
					</Link>
				)}
				<div className={styles('content')}>
					<Theme.H4 className={styles('content-title')}>
						<Link to={url} className={styles('content-title-link')}>
							{title}
						</Link>
					</Theme.H4>
					{text && <Theme.Wysiwyg>{text}</Theme.Wysiwyg>}
					{url && (
						<Theme.Link to={url} className={styles('content-link')}>
							{btnlabel || title}
						</Theme.Link>
					)}
				</div>
			</div>
		</Block>
	)
}
